import React from 'react';
import { useTranslation } from 'react-i18next';
import { vacationTypeKey } from '../utils/vacationTypes';
import VacationTextFields from './VacationTextFields';
 
const SectionEditVacation = ({ formData , onChange }) => {
  const { t } = useTranslation();

  return (
    <div className="mb-6">
       <div className="grid grid-cols-1 md:grid-cols-1 gap-6"> 
              </div>
              <div className="mt-4 grid grid-cols-1 md:grid-cols-1 gap-6">
                <div>
                  <p className="mt-4 text-lg font-semibold">
                    {t("choose_property_type")}
                  </p>
                  <div className="mt-4 flex space-x-2">
                  <button
                  type="button"
                  id="category"
                  value="Appartement"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    vacationTypeKey(formData.category) === "entirePlace" ? "bg-white text-black" : "bg-slate-600 text-white"
                  }`}
                >
                   {t('entirePlace')}  
                </button>
                <button
                  type="button"
                  id="category"
                  value="Maison"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    vacationTypeKey(formData.category) === "oneRoom" ? "bg-white text-black" : "bg-slate-600 text-white"
                  }`}
                >  
               {t('oneRoom')} 
                </button>
                <button
                  type="button"
                  id="category"
                  value="commercial"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    vacationTypeKey(formData.category) === "sharedRoom" ? "bg-white text-black" : "bg-slate-600 text-white"
                  }`}
                >
                {t('sharedRoom')}
                </button>  
                 
                 
                  </div>
                </div>
              </div>
        
              <VacationTextFields titleId="libelle" descriptionId="description" titleRequired
                title={formData.libelle} description={formData.description} onChange={onChange} />
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <p className="text-lg font-semibold">{t('bedrooms')}</p>
                    <input
                      type="number"
                      id="chambres"
                      value={formData.chambres}
                      onChange={onChange}
                      min="0"
                      max="50"
                      required
                      className="w-full px-4 py-2 text-xl text-gray-700 bg-white border border-gray-300 rounded transition duration-150 ease-in-out focus:text-gray-700 focus:bg-white focus:border-slate-600 text-center"
                    />
                  </div>
                  <div>
                    <p className="text-lg font-semibold">{t('lord')}</p>
                    <input
                      type="number"
                      id="maxGuests"
                      value={formData.maxGuests}
                      onChange={onChange}
                      min="1"
                      max="50"
                      required
                      className="w-full px-4 py-2 text-xl text-gray-700 bg-white border border-gray-300 rounded transition duration-150 ease-in-out focus:text-gray-700 focus:bg-white focus:border-slate-600 text-center"
                    />
                  </div>
                  <div>
                    <p className="text-lg font-semibold">{t('beds')}</p>
                    <input
                      type="number"
                      id="lits"
                      value={formData.lits}
                      onChange={onChange}
                      min="0"
                      max="50"
                      required
                      className="w-full px-4 py-2 text-xl text-gray-700 bg-white border border-gray-300 rounded transition duration-150 ease-in-out focus:text-gray-700 focus:bg-white focus:border-slate-600 text-center"
                    />
                  </div>
                  <div>
                    <p className="text-lg font-semibold">{t('bathroom')}</p>
                    <input
                      type="number"
                      id="sallesBains"
                      value={formData.sallesBains}
                      onChange={onChange}
                      min="1"
                      max="50"
                      required
                      className="w-full px-4 py-2 text-xl text-gray-700 bg-white border border-gray-300 rounded transition duration-150 ease-in-out focus:text-gray-700 focus:bg-white focus:border-slate-600 text-center"
                    />
                  </div>
                </div>
               
              {formData.category !== "Terrain" && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-lg font-semibold">
                      {t("parking")}
                    </label>
                    <div className="flex items-center space-x-4">
                      <button
                        type="button"
                        id="parking"
                        value={true}
                        onClick={onChange}
                        className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                          formData.parking
                            ? "bg-slate-600 text-white"
                            : "bg-white text-black"
                        }`}
                      >
                        {t("yes")}
                      </button>
                      <button
                        type="button"
                        id="parking"
                        value={false}
                        onClick={onChange}
                        className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                          !formData.parking
                            ? "bg-slate-600 text-white"
                            : "bg-white text-black"
                        }`}
                      >
                        {t("non")}
                      </button>
                    </div>
                  </div>
                  <div>
                    <label className="block text-lg font-semibold">
                      {t("furnished")}
                    </label>
                    <div className="flex items-center space-x-4">
                      <button
                        type="button"
                        id="meuble"
                        value={true}
                        onClick={onChange}
                        className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                          formData.meuble
                            ? "bg-slate-600 text-white"
                            : "bg-white text-black"
                        }`}
                      >
                        {t("yes")}
                      </button>
                      <button
                        type="button"
                        id="meuble"
                        value={false}
                        onClick={onChange}
                        className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                          !formData.meuble
                            ? "bg-slate-600 text-white"
                            : "bg-white text-black"
                        }`}
                      >
                        {t("non")}
                      </button>
                    </div>
                  </div>
                </div>
              )}

    </div>
  );
};

export default SectionEditVacation;
